import useApi from "./useApi";

/**
 * useOrders hook
 */
const useOrders = ({ query = {}, page = 1, perPage = 10 } = {}) => {
  const { get } = useApi();

  const params = { ...query, page, per_page: perPage };
  const qs = "?" + new URLSearchParams(params).toString();

  const { data, isLoading, error } = get("/admin/orders" + qs);

  return {
    orders: data?.data?.orders || [],
    pagination: {
      current_page: data?.data?.current_page || 1,
      per_page: data?.data?.per_page || perPage,
      total: data?.data?.total || 0,
      last_page: data?.data?.last_page || 1,
    },
    isLoading,
    error,
  };
};

export default useOrders;
